module.exports = __webpack_public_path__ + "img/show4.aac076b2.png";